import getOrderDetails from "../Orders/getOrderDetails";

export const calculateTaxes = async (cart: any) => {
    const tax_included = cart.tax_included || false;
    const global_tax_rate = Number(cart.tax_rate) || 0;
    
    // Calculate total tax amount for all products
    let total_products_tax = 0;
    
    cart.products = cart.products.map((product: any) => {

        const product_tax_rate = Number(product.product_tax) || 0;
        const original_price = Number(product.original_price || product.product_price) || 0;
        const product_quantity = Number(product.product_quantity) || 1;
        const product_discount = Number(product.product_discount) || 0;
        
        let tax_amount = 0;
        let full_price = original_price;
        let real_price = 0;
        let product_price = original_price; // This will be updated based on tax inclusion
            
        if (tax_included) {
            const price_without_tax = Math.round(original_price / (1 + product_tax_rate / 100) * 100) / 100;
            const total_price_without_tax = price_without_tax * product_quantity;
            
            // Check if discount equals or exceeds the total price without tax for the entire quantity
            if (product_discount >= total_price_without_tax) {
                tax_amount = 0;
                full_price = 0;
                real_price = 0;
                product_price = price_without_tax; // Set product_price to price without tax per unit
            } else {
                // Calculate per-unit discount
                const discount_per_unit = product_discount / product_quantity;
                // Apply discount to the final price (with taxes included) and round to avoid precision errors
                const price_after_discount = Math.round((original_price - discount_per_unit) * 100) / 100;
                
                // Calculate what the price without tax would be after discount
                const price_without_tax_after_discount = Math.round(price_after_discount / (1 + product_tax_rate / 100) * 100) / 100;
                tax_amount = Math.round((price_after_discount - price_without_tax_after_discount) * 100) / 100;
                full_price = price_after_discount;
                real_price = price_after_discount;
                product_price = price_without_tax; // Set product_price to price without tax per unit
            }

        } else {
            // Calculate per-unit discount
            const discount_per_unit = product_discount / product_quantity;
            real_price = Math.round((original_price - discount_per_unit) * 100) / 100;
            
            // Ensure real_price doesn't go below 0 (100% discount scenario)
            if (real_price <= 0) {
                real_price = 0;
                tax_amount = 0;
                full_price = 0;
            } else {
                tax_amount = Math.round((real_price * product_tax_rate / 100) * 100) / 100;
                full_price = Math.round((real_price + tax_amount) * 100) / 100;
            }
            product_price = original_price; 
        }
            
        let bundle_tax_amount = 0;
        let updated_bundle_products = [];
            
        if (product.bundle_products && product.bundle_products.length > 0) {
            console.log('Processing bundle products for product:', product.product_name);
            updated_bundle_products = product.bundle_products.map((bundle: any) => {
                const bundle_original_price = Number(bundle.original_price || bundle.price) || 0;
                const bundle_quantity = Number(bundle.quantity) || 1;

                let bundle_tax = 0;
                let bundle_price_without_tax = bundle_original_price;
                let bundle_full_price = bundle_original_price;
                
                if (tax_included) {
                    bundle_price_without_tax = Math.round(bundle_original_price / (1 + product_tax_rate / 100) * 100) / 100;
                    bundle_tax = Math.round((bundle_original_price - bundle_price_without_tax) * 100) / 100;
                    bundle_full_price = bundle_original_price;
                } else {
                    bundle_tax = Math.round((bundle_original_price * product_tax_rate / 100) * 100) / 100;
                    bundle_full_price = Math.round((bundle_original_price + bundle_tax) * 100) / 100;
                    bundle_price_without_tax = bundle_original_price;
                }
                
                // Add bundle tax to total (multiplied by main product quantity)
                bundle_tax_amount += (bundle_tax * bundle_quantity) * product_quantity;
                
                console.log('Bundle product tax calculation:', {
                    bundle_name: bundle.name || 'Unknown',
                    bundle_original_price,
                    bundle_price_without_tax,
                    bundle_tax,
                    bundle_full_price,
                    product_quantity,
                    tax_included
                });
                
                return {
                    ...bundle,
                    original_price: bundle_original_price.toFixed(2),
                    price: bundle_price_without_tax.toFixed(2),
                    tax_amount: bundle_tax.toFixed(2),
                    full_price: bundle_full_price.toFixed(2),
                    tax_included: tax_included
                };
            });
            
            console.log('Total bundle tax amount:', bundle_tax_amount);
        }
            
        // Add to total tax (multiplied by quantity) including bundle products tax
        total_products_tax += (tax_amount * product_quantity) + bundle_tax_amount;
        
        return {
            ...product,
            original_price: original_price.toFixed(2), // Store the original price
            product_tax: product_tax_rate.toFixed(2),
            tax_amount: tax_amount.toFixed(2),
            product_price: product_price.toFixed(2), // This is now the calculated price without tax when tax_included
            full_price: full_price.toFixed(2),
            tax_included: tax_included,
            bundle_products: updated_bundle_products // Include updated bundle products with tax calculations
        };
    
    });
    

    // Calculate shipping tax
    const shipping_price = Number(cart.shipping_price) || 0;
    let shipping_tax = 0;
    
    if (shipping_price > 0) {
        shipping_tax = Math.round((shipping_price * global_tax_rate / 100) * 100) / 100;
    }
    
    // Update cart with tax information
    cart.tax_rate = global_tax_rate;
    cart.tax_included = tax_included;
    // Ensure total tax doesn't go negative
    cart.total_tax = Math.max(0, Math.round((total_products_tax + shipping_tax) * 100) / 100);
    
    if (tax_included) {
        // If taxes are included, total_price_with_tax is the same as subtotal + shipping
        const calculatedTotal = cart.subtotal_price + shipping_price;
        cart.total_price_with_tax = Math.max(0, Math.round(calculatedTotal * 100) / 100).toFixed(2);
    } else {
        // If taxes are not included, add taxes to the total
        const calculatedTotal = cart.subtotal_price + shipping_price + cart.total_tax;
        cart.total_price_with_tax = Math.max(0, Math.round(calculatedTotal * 100) / 100).toFixed(2);
    }
    
    // Save updated cart back to localStorage
    localStorage.setItem('cart', JSON.stringify(cart));
    // Limpia el error de impuestos si existe
    localStorage.removeItem('tax_error');
    getOrderDetails("checkout");
    
    return cart;
}